import frTranslations from './fr.json';
import enTranslations from './en.json';

const translations = {
  fr: frTranslations,
  en: enTranslations
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language] || translations['fr'];
  
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      // Fallback to French
      value = translations['fr'];
      for (const k2 of keys) {
        value = value?.[k2];
      }
      break;
    }
  }
  
  return value || key;
};

export const t = getTranslation;

export default translations;
